import { handleActions } from 'redux-actions';
import { constants } from './actions';


export const initialState = {
  companyLoginImage: null,
  companyLoginCoverImage: null,
};

const handleSetCompanyLoginImage = (state, { payload }) => (
  {
    ...state,
    companyLoginImage: payload,
  });

const handleSetCompanyLoginCoverImage = (state, { payload }) => (
  {
    ...state,
    companyLoginCoverImage: payload,
  });


export default handleActions({
  [constants.setCompanyLoginImage]: handleSetCompanyLoginImage,
  [constants.setCompanyLoginCoverImage]: handleSetCompanyLoginCoverImage,
}, initialState);
